import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat' // 引入 localizedFormat 插件

dayjs.extend(localizedFormat) // 使用插件

export const dateFilter = {
  year: value => formatDate(value, 'YYYY'),
  month: value => formatDate(value, 'MM'),
  day: value => formatDate(value, 'DD'),
  yearMonth: value => formatDate(value, 'YYYY-MM'),
  monthDay: value => formatDate(value, 'MM-DD'),
  default: (value, format = 'YYYY-MM-DD') => formatDate(value, format),
  enDate: value => formatDate(value, 'MMMM D[,] YYYY HH:mm a'), // 新增英文日期格式化
  enDateWithOrdinal: value => formatEnDateWithOrdinal(value),
  enDateNoTime:value=>formatDate(value,'MMMM D[,] YYYY')
}

function formatDate(value, format) {
  if (!value) return ''
  const date = dayjs(value)
  return date.isValid() ? date.format(format) : ''
}

function getOrdinalSuffix(day) {
  if (day > 3 && day < 21) return 'TH' // 11TH, 12TH, 13TH
  switch (day % 10) {
    case 1: return 'ST'
    case 2: return 'ND'
    case 3: return 'RD'
    default: return 'TH'
  }
}

function formatEnDateWithOrdinal(value) {
  if (!value) return ''
  const date = dayjs(value)
  if (!date.isValid()) return ''

  const month = date.format('MMMM').toUpperCase() // 获取全大写的月份
  const day = date.date() // 获取日期数字
  const year = date.year() // 获取年份
  const suffix = getOrdinalSuffix(day) // 获取序数词后缀

  return `${month} ${day}${suffix}, ${year}`
}